const logError = (e: Error) => {
  console.error(`Analytic error occurred: ${e}`);
};

export default logError;
